module.exports = "/packs/images/bffs_2025_logo_small~cc467e91b1444caeaa8d166c3cc847ef.jpg";